// Account integrations that only work with an IoT Data Hub (n1) behind niotix: the n1 InfluxDB
// integration provisions a database on the IoT Data Hub. Grafana, the States InfluxDB data source and
// IEC-104 do not depend on n1. Mirrors backend/unify-service/mixins/iot-data-hub/constants.js.
export const IOT_HUB_INTEGRATION_TYPES = ['influxdb'];

export const withoutIotHubIntegrationTypes = (integrations, n1Enabled) => {
  if (n1Enabled) {
    return integrations;
  }

  return (integrations || []).filter((integration) => !IOT_HUB_INTEGRATION_TYPES.includes(integration.type));
};
